import React, { useEffect } from "react";
import TTSelect from "./TTSelect/TTSelect";

export default function TtRadioImg(props) {
  const { component, handleChange, toIntIf, values } = props;

  return (
    <TTSelect
      className="BT2"
      placeholder={`Seleziona ...`}
      options={component.permittedValues.map((v, k) => {
        if (typeof v === "object" && v !== null) {
          return {
            ...v,
            text: v.description,
            value: v.code,
            id: k,
            img: v.file
              ? `${process.env.REACT_APP_IMAGE_PATH}${v.file}.png`
              : false,
          };
        }
        return { text: v, value: v, id: k };
      })}
      value={values[component.name]}
      name={component.name}
      onChange={(value) => {
        handleChange({ [component.name]: toIntIf(value) });
      }}
    />
  );
}
